import { StringField } from "../../../types/types";
import {
  PrivacyBannerFields,
  PrivacyBannerProps,
} from "../types/PrivacyBanner.types";

export class PrivacyBannerModel {
  private readonly fields?: PrivacyBannerFields;

  constructor(props: PrivacyBannerProps) {
    this.fields = props.fields;
  }

  get title(): StringField | undefined {
    return this.fields?.Title
  }

  get subtitle(): StringField | undefined {
    return this.fields?.SubTitle
  }
}
